import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import DropDownReviewShareItem from './DropDownReviewShareItem';
import DropDownPostShareItem from './DropDownPostShareItem';
import DropDownReviewReportItem from './DropDownReviewReportItem';
import DropDownPostReportItem from './DropDownPostReportItem';
import DropDownReviewDeleteItem from './DropDownReviewDeleteItem';
import DropDownPostDeleteItem from './DropDownPostDeleteItem';

const DropDownReview = (props) => {
   
    const [open, setOpen] = useState(false);
    const [isReviewDeleteable, setReviewDeleteable] = useState(false);
    const [isPostDeleteable, setPostDeleteable] = useState(false);
    const { user } = useSelector((state) => state.user);

    useEffect(() => {
        if(user && props.review) {
            if(props.review.user_id == user.id) {
                setReviewDeleteable(true)
            }
        }
    }, [props.review, user]);

    useEffect(() => {
        if(user && props.post) {
            if(props.post.user_id == user.id) {
                setPostDeleteable(true)
            }
        }
    }, [props.post, user]);

    const toggleDropDown = () => {
        setOpen(!open);
    }

    return (
        <>
            <div className="review-comment-report">
                <div className="scroll-nav-wrapper-review">
                    <div className="container">
                        <div className="scroll-nav-wrapper-opt-review">
                            <div 
                                className={open ? "show-more-snopt scwllink" : "show-more-snopt"} 
                                onClick={() => toggleDropDown()}
                            >
                                <i className="fal fa-ellipsis-h"></i>
                            </div>
                            <div className={open ? "show-more-snopt-tooltip show-more-snopt-tooltip_vis" : "show-more-snopt-tooltip"}>
                                {props.review && 
                                    (
                                        <DropDownReviewShareItem
                                            review={props.review}
                                            listing={props.listing} 
                                        />
                                    )
                                }
                                {props.post && 
                                    (
                                        <DropDownPostShareItem
                                            post={props.post} 
                                        />
                                    )
                                }
                                {props.review && !isReviewDeleteable && 
                                    (
                                        <DropDownReviewReportItem 
                                            review={props.review}
                                        />
                                    )
                                }
                                {props.post && !isPostDeleteable && 
                                    (
                                        <DropDownPostReportItem 
                                            post={props.post}
                                        />
                                    )
                                }
                                {isReviewDeleteable && 
                                    (
                                        <DropDownReviewDeleteItem
                                            index={props.index}
                                            review={props.review}
                                            setDeletedIndex={props.setDeletedIndex} 
                                        />  
                                    )
                                }
                                {isPostDeleteable && 
                                    (
                                        <DropDownPostDeleteItem
                                            index={props.index}
                                            post={props.post}
                                            setDeletedIndex={props.setDeletedIndex} 
                                        />
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>																 
            </div>
        </>
    );
};

export default DropDownReview;